export const skillset_list = [
  {
    label: 'React',
    value: 'react',
  },
  {
    label: 'React Native',
    value: 'react native',
  },
  {
    label: 'UI/UX Design',
    value: 'ui/ux design',
  },
  {
    label: 'Product Management',
    value: 'product management',
  },
  {
    label: 'Backend',
    value: 'backend',
  },
  {
    label: 'Go',
    value: 'go',
  },
  {
    label: 'Python',
    value: 'python',
  },
  {
    label: 'Java',
    value: 'java',
  },
  {
    label: 'Microsoft Office',
    value: 'microsoft office',
  },
  {
    label: 'Agile Software',
    value: 'agile software',
  },
  {
    label: 'SQL',
    value: 'sql',
  },
  {
    label: 'C++',
    value: 'c++',
  },
  {
    label: 'Leadership',
    value: 'leadership',
  },
  {
    label: 'Databases',
    value: 'databases',
  },
  {
    label: 'REST',
    value: 'rest',
  },
  {
    label: 'JUnit',
    value: 'junit',
  },
  {
    label: 'Git',
    value: 'git',
  },
  {
    label: 'AngularJS',
    value: 'angularjs',
  },
  {
    label: 'User Research',
    value: 'user research',
  },
  {
    label: 'AWS',
    value: 'aws',
  },
  {
    label: 'JavaScript',
    value: 'javascript',
  },
  {
    label: 'Flexibility',
    value: 'flexibility',
  },
  {
    label: 'Full-stack',
    value: 'full-stack',
  },
  {
    label: 'Django',
    value: 'django',
  },
  {
    label: 'jQuery',
    value: 'jquery',
  },
  {
    label: 'Rust',
    value: 'rust',
  },
  {
    label: 'Swift',
    value: 'swift',
  },
];
